export const snapLoginConstants = {
  SNAP_LOGIN_LOADING: "SNAP_LOGIN_LOADING",
  SNAP_LOGIN_SUCCESS: "SNAP_LOGIN_SUCCESS",
  SNAP_LOGIN_ERROR: "SNAP_LOGIN_ERROR"
}
